<template>
  <div class="">
    <el-dialog
      :title="$t('product.LookImgs.519966-1')"
      :visible.sync="show"
      :modal-append-to-body="true"
      :append-to-body="true"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @open="open"
      width="48%"
      @close="close"
    >
      <div class="showWrap" v-loading="loading">
        <div v-for="(item, index) in previewList" :key="index" class="img_item">
          <div class="img_item_img" :style="{ backgroundImage: `url(${item.image})` }">
            <div class="img_hide">
              <i @click="handlerYl(index)" class="el-icon-view"></i>
            </div>
          </div>
        </div>
        <el-empty v-if="!loading && previewList.length === 0" :description="$t('common.noData')" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close" size="small">{{ $t("product.LookImgs.519966-4") }}</el-button>
      </span>
    </el-dialog>
    <el-image-viewer
      v-if="showPhotoList"
      :initial-index="nowIndex"
      :on-close="closeViewer"
      :zIndex="9999"
      :url-list="showBigImgList"
    />
  </div>
</template>

<script>
export default {
  components: {
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer")
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      nowIndex: 1,
      previewList: [],
      showBigImgList: [],
      showPhotoList: false,
      loading: false
    };
  },
  methods: {
    open() {
      this.previewList = [];
      this.showBigImgList = [];
      this.loading = false;
      this.getImgs();
    },
    async getImgs() {
      const goodsId = this.product && (this.product.goodsId || this.product.id);
      if (!goodsId) {
        this.$message.warning(this.$t("common.noData"));
        return;
      }

      this.loading = true;
      try {
        const res = await this.$api.request(this.$url.OpenDoor.getSkuImageList, this.$method.get, {
          goodsId
        });
        if (res.code === 0) {
          this.previewList = Array.isArray(res.data && res.data.records) ? res.data.records : [];
          this.previewList.forEach(item => {
            this.showBigImgList.push(item.image);
          });
        } else {
          this.$message.warning(res.msg);
        }
      } catch (error) {
        this.$message.error(this.$t("product.LookImgs.519966-9"));
        console.log("error:", error);
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.$emit("close");
    },
    closeViewer() {
      this.showPhotoList = false;
    },
    handlerYl(index) {
      this.nowIndex = index;
      this.showPhotoList = true;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  height: auto !important;
}
.showWrap {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  grid-template-rows: masonry;
  justify-content: center;
  grid-auto-flow: dense;
  min-height: 300px; /* 确保空状态有空间居中 */
}

.img_item {
  position: relative;
  width: 160px;
  height: 160px;
  box-shadow: 0 0 3px #ccc;

  .img_item_img {
    cursor: pointer;
    height: 160px;
    width: 100%;
    font-size: 0;
    background: center center / contain no-repeat;
    .img_hide {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      opacity: 0;
      transition: all 0.4s ease-in-out;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        height: 20px;
        width: 20px;
        font-size: 18px;
        margin-right: 5px;
        margin: 0 10px;
      }
    }
    &:hover {
      .img_hide {
        opacity: 1;
      }
    }
    img {
      object-fit: contain;
    }
  }
}

/* 空状态居中 */
::v-deep .el-empty {
  grid-column: 1 / -1;
  justify-self: center;
  align-self: center;
  padding: 40px 0;
}
</style>
